
import {
    elementInViewport
  } from "@/utils/utils"


export default async () => {
      // reviews

  // remove ssr reviews
  const ssrDomElements = document.querySelector("#ssr-review-contents")
  if (ssrDomElements) ssrDomElements.remove()

  let throttleTimer;
  const throttleDelay = 100;

  async function initReviews() {
    const reviewsRoot = document.querySelector('#review-app');
    const reviewsSection = document.querySelector("section.tf-reviews")
    if (reviewsRoot && reviewsSection && elementInViewport(reviewsSection)) {
      await window.appInitializer.initReviewApp()
      window.removeEventListener('scroll', throttledInitReviews)
    }
  }

  function throttledInitReviews() {
    clearTimeout(throttleTimer);
    throttleTimer = setTimeout(initReviews, throttleDelay);
  }

  window.addEventListener('scroll', throttledInitReviews)

}